// extracted by mini-css-extract-plugin
module.exports = {"author-container":"Author_author-container__EF2mO","avatar":"Author_avatar__6_O3F","date":"Author_date__rhn6y"};